import { computed } from 'vue';

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-ri-cloudy-fill',
    'Channel::Email': 'i-ri-mail-fill',
    'Channel::FacebookPage': 'i-ri-messenger-fill',
    'Channel::Line': 'i-ri-line-fill',
    'Channel::Sms': 'i-ri-chat-1-fill',
    'Channel::Telegram': 'i-ri-telegram-fill',
    'Channel::TwilioSms': 'i-ri-chat-1-fill',
    'Channel::TwitterProfile': 'i-ri-twitter-x-fill',
    'Channel::WebWidget': 'i-ri-global-fill',
    'Channel::Whatsapp': 'i-ri-whatsapp-fill',
    'Channel::ZaloOa': 'i-ri-chat-1-fill',
    'Channel::ZaloPersonal': 'i-ri-chat-1-fill',
  };

  const providerIconMap = {
    microsoft: 'i-ri-microsoft-fill',
    google: 'i-ri-google-fill',
  };

  const channelIcon = computed(() => {
    const type = inbox.channel_type;
    // Twilio WhatsApp: override when medium === 'whatsapp'
    if (type === 'Channel::TwilioSms' && inbox.medium === 'whatsapp') {
      return 'i-ri-whatsapp-fill';
    }
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inbox.provider) {
      if (Object.keys(providerIconMap).includes(inbox.provider)) {
        icon = providerIconMap[inbox.provider];
      }
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}

export function useChannelBrandColor(inbox) {
  const channelTypeColorMap = {
    'Channel::Api': 'var(--color-cloud-generic)',
    'Channel::Email': '#EA4335', // Gmail red
    'Channel::FacebookPage': 'var(--color-facebook-brand)',
    'Channel::Line': '#00B900', // Line green
    'Channel::Sms': 'var(--color-sms-twilio)',
    'Channel::Telegram': '#0088cc', // Telegram blue
    'Channel::TwilioSms': 'var(--color-sms-twilio)',
    'Channel::TwitterProfile': 'var(--color-twitter-brand)',
    'Channel::WebWidget': 'var(--color-hichat)',
    'Channel::Whatsapp': 'var(--color-whatsapp-brand)',
  };

  const providerColorMap = {
    microsoft: '#00A1F1', // Microsoft blue
    google: '#EA4335', // Gmail red
  };

  const channelColor = computed(() => {
    const type = inbox.channel_type;
    let color = channelTypeColorMap[type];

    if (type === 'Channel::Email' && inbox.provider) {
      if (Object.keys(providerColorMap).includes(inbox.provider)) {
        color = providerColorMap[inbox.provider];
      }
    }

    return color ?? 'var(--color-hichat)';
  });

  return channelColor;
}
